module.exports = __webpack_public_path__ + "img/HU.576ac7f9.svg";